//src/app/features/taxEstimates/EditTaxEstimate.tsx
import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import { useUpdateTaxEstimateMutation } from 'app/services/taxEstimates';
import { SaveIcon } from 'assets/icons';
import Button from 'Components/Buttons/Button';
import Spinner from 'Components/Spinner';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';
import TaxEstimateForm from './TaxEstimateForm';
import useTaxEstimate from './useTaxEstimate';

export default function EditTaxEstimate() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data } = useTaxEstimate();
  const [UpdateTrigger, { isLoading }] = useUpdateTaxEstimateMutation();

  useEffect(() => {
    if (!data) return;
    if (data.status !== 'submitted') navigate('..');
  }, [JSON.stringify(data)]);

  if (!data || !user) return <Spinner />;

  return (
    <>
      <DashboardContainerHeader title={data.title}>
        <Button
          form="tax-estimate-form"
          className="max-w-min"
          isLoading={isLoading}
        >
          <SaveIcon className="w-4 h-4" />
          Save
        </Button>
      </DashboardContainerHeader>

      <TaxEstimateForm
        value={data.data}
        onChange={(taxEstimate) => {
          return UpdateTrigger({ ...taxEstimate, id: data.id })
            .unwrap()
            .then(() => navigate('..'));
        }}
        isLoading={isLoading}
      />
    </>
  );
}
